import { useContext } from 'react'
import { StyledAccordionHeader } from './AccordionHeader.styles'
import { AccordionHeaderProps } from './AccordionHeader.types'
import { AccordionContext } from 'components/shared/Accordion/utils/accordionContext'
import Box from 'components/shared/Box'
import Icon from 'components/shared/Icon'
import Text from 'components/shared/Text'

export const AccordionHeader = ({
    children,
    description,
    isExpanded,
    id,
    'data-testid': testId,
}: AccordionHeaderProps) => {
    const { toggleAccordion } = useContext(AccordionContext)
    const onClick = () => toggleAccordion?.(id ?? '')

    return (
        <StyledAccordionHeader
            type="button"
            id={`header-${id}`}
            onClick={onClick}
            aria-expanded={isExpanded}
            aria-controls={`panel-${id}`}
            data-testid={testId ? `${testId}-toggle` : undefined}
        >
            <Box direction="column" gap={4}>
                {children}
                {!!description && !isExpanded && (
                    <Text variant="bodySmall" color="secondary_500">
                        {description}
                    </Text>
                )}
            </Box>
            <Icon variant="chevron" rotation={isExpanded ? -180 : 0} />
        </StyledAccordionHeader>
    )
}
